import { em } from 'polished'
import styled from 'styled-components'

import Cost from 'components/Cost'
import { Col, Row } from 'styles/components/layout'
import { TextSmallDescr } from 'styles/components/typography'

export const RowStyled = styled(Row)`
  ${p => p.theme.mq.upLg} {
    min-height: ${em(158)};
  }
`

export const ColStyled = styled(Col)`
  padding-left: ${em(20)};
`

export const CostStyled = styled(Cost)`
  font-family: ${p => p.theme.typography.mediumFont};
`

export const IndentBlock = styled.div`
  ${p => p.theme.mq.upMd} {
    display: none;
  }
`

export const VatWrapper = styled.div`
  padding-top: ${em(5)};
  max-width: ${em(141)};
`

export const Vat = styled(TextSmallDescr)`
  display: block;
  color: ${p => p.theme.colors.muted};
`
